import { Injectable } from '@angular/core';
import { Log } from './console.log';

const TOKEN_KEY = 'Authorization';
const USER_KEY = 'currentUserProfile';
const LOCALIZE_DEFAULT_LANGUAGE = 'LOCALIZE_DEFAULT_LANGUAGE';
const FORGET_FORM_KEY = '_forget_';
const REFRESH_KEY = 'Refresh';

@Injectable()
export class UserFactory {
  constructor() {}

  signOut() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    // Don't remove LOCALIZE_DEFAULT_LANGUAGE as it will be preserved in clearSeesion()
    // localStorage.removeItem(LOCALIZE_DEFAULT_LANGUAGE);

    // Preserve specific keys before clearing localStorage
    const preservedKeys: { [key: string]: string } = {};
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('news_popup_read_') || key === LOCALIZE_DEFAULT_LANGUAGE) {
        preservedKeys[key] = localStorage.getItem(key);
      }
    });

    try { localStorage.clear(); } catch (error) { console.error('Failed to clear localStorage:', error); }

    // Restore preserved keys
    Object.keys(preservedKeys).forEach(key => {
      localStorage.setItem(key, preservedKeys[key]);
    });
  }

  public saveTokenAndProfile(token: string, profile: string) {
    this.saveToken(token);
    this.saveProfile(profile);
  }

  public saveTokenAndRefreshAndProfile(token: string, refreshToken: string, profile: string) {
    this.saveToken(token);
    this.saveRefreshToken(refreshToken);
    this.saveProfile(profile);
  }

  public saveToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
  }

  public saveRefreshToken(token: string) {
    localStorage.setItem(REFRESH_KEY, token);
  }

  public saveProfile(profile: any) {
    const str = JSON.stringify(profile);
    const data = this.encrypt(str);
    localStorage.setItem(USER_KEY, data);
  }

  public getToken(): string {
    return localStorage.getItem(TOKEN_KEY);
  }

  public getRefreshToken(): string {
    return localStorage.getItem(REFRESH_KEY);
  }

  public getProfile(): string {
    const data = this.decrypt(localStorage.getItem(USER_KEY));
    return JSON.parse(data);
  }

  public getAgentCode(): string {
    return this.getProfile();
  }

  public setCurrentLang(lang: string) {
    return localStorage.setItem(LOCALIZE_DEFAULT_LANGUAGE, lang);
  }

  public getCurrentLang(): string {
    return !!localStorage.getItem(LOCALIZE_DEFAULT_LANGUAGE) ? localStorage.getItem(LOCALIZE_DEFAULT_LANGUAGE) : 'th';
  }

  public getForgetForm(): any {
    const data = sessionStorage.getItem(FORGET_FORM_KEY);
    if (!!data){
      return  JSON.parse(this.decrypt(data));
    }
    return null;
  }

  public saveSessionForgetForm(data: any, email: string): any {
    const obj = {
      email: email,
      form: data
    };
    sessionStorage.setItem(FORGET_FORM_KEY, this.encrypt(JSON.stringify(obj)));
  }

  public clearForgetForm(): any {
    return sessionStorage.removeItem(FORGET_FORM_KEY);
  }

  private encrypt(data: any): string {
    return  btoa(data);
  }

  private decrypt(data: any): string {
    return atob(data);
  }
}
